// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"72":"97cab57e","140":"87c827e2","534":"87c827e2","569":"87c827e2","783":"87c827e2"}[chunkId] + ".chunk.css";
};